// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const scData = (data: any) => ({
  currency: data?.currency || '',
  items: data?.items || [],
  transaction_id: data?.transaction_id || '',
  tax: data?.tax || 0,
  shipping: data?.shipping || 0,
  coupon: data?.coupon || '',
  payment_type: data?.payment_type || '',
});
